/**
 * Legacy module — preserved as an empty module so existing dependencies
 * (`acme.common.service.reports`) keep resolving.
 *
 * The real implementation lives at:
 *   apps/b2b-frontend/app/core/reports/reports.service.ts
 *
 * It's registered with AngularJS in
 *   apps/b2b-frontend/app/upgrade/ng-downgraded-components.ts
 * via downgradeInjectable, so any `$inject = ['ReportsService']` resolves
 * to the Angular 18 class. Wave 3 item #16.
 */
angular.module('acme.common.service.reports', ['acme.common.service.reports.generator']);
